module.exports = __webpack_public_path__ + "static/design-632f8ad8de87e4a4529a6c87e963633e.svg";